import { identity, memoizeWith } from 'ramda';
function getCustomTooltipSizeStyles(size) {
  return require("./".concat(size, ".module.css"));
}
export const getSizeStyles = memoizeWith(identity, getCustomTooltipSizeStyles);